export const tokenMiddlewareController: {
  promise: Promise<any> | null;
  resolve: (() => void) | null;
} = {
  promise: null,
  resolve: null,
};
